import { useContext, useEffect, useState } from 'react';
import { AudioContext } from '../libs/audio-provider';
import { BackgroundContext } from '../libs/BackgroundProvider';
import { useGameContext } from "../libs/GameProvider";
import Modal from './ui/Modal';
import SvgButton from './ui/SvgButton';

interface GameCoverProps {
  onClick?: () => void,
}

export default function GameCover(props: GameCoverProps) {
  const { playClick } = useContext(AudioContext);
  const { setBg } = useContext(BackgroundContext);
  const { gameDifficulty, dispatch } = useGameContext();
  const [modalShow, setModalShow] = useState(false);

  useEffect(() => {
    setBg('1-game-cover/cover-background', '1-game-cover/background');
  }, [setBg]);

  return (
    <div className="fullscreen">
      <div className="container">
        {/* <button className="difficulty-button" style={{ right: 100, top: 20, width: 78, height: 78 }} onClick={() => { playClick(); dispatch(`difficulty-${3 === gameDifficulty.difficulty ? 1 : 3}`) }}>
          {
            3 === gameDifficulty.difficulty
              ? <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/1-game-cover/cover-button9`} src1="-select.svg" src2=".svg" alt="進階"></SvgButton>
              : <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/1-game-cover/cover-button9`} src1=".svg" src2="-select.svg" alt="進階"></SvgButton>
          }
        </button> */}
        <button className="cover-button" style={{ right: 20, top: 20, width: 78, height: 78 }} onClick={() => { playClick(); setModalShow(true) }}>
          <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/1-game-cover/cover-description-button`} src1=".svg" src2="-select.svg" alt="遊戲概念"></SvgButton>
        </button>
        {modalShow
          ? <Modal>
            <div className="modal" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/1-game-cover/cover-popup.svg` }}>
              <button className="modal-button-close" onClick={() => { setModalShow(false); }}>
                <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/1-game-cover/cover-close-button`} src1=".svg" src2="-select.svg" alt="關閉"></SvgButton>
              </button>
              <div className="modal-content">
                <p>
                  四大發明是關於中國科學技術史的一種觀點，<br />
                  是指古代中國的四種發明，<br />
                  一般是指造紙術、指南針、火藥及印刷術。<br />
                  希望透過四款小遊戲幫助學生掌握四大發明的步驟及如何改變日後世界。</p>
              </div>
            </div>
          </Modal>
          : null}

        <button className="cover-button" style={{ right: 200, bottom: 0, width: 463, height: 389 }} onClick={() => { playClick(); dispatch({ type: 'game-printing', state: 'cover' }) }}>
          <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/1-game-cover/cover-button5`} src1=".svg" src2="-select.svg" alt="印刷術"></SvgButton>
        </button>
        <button className="cover-button-caption cover-button-caption-game-printing" style={{ right: 516, top: 323, width: 143, height: 116 }} onClick={() => { playClick(); dispatch({ type: 'game-printing', state: 'cover' }) }}>
          <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/1-game-cover/cover-button3`} src1=".svg" src2=".svg" alt="印刷術"></SvgButton>
        </button>

        <button className="cover-button" style={{ left: 303, bottom: 34, width: 305, height: 363 }} onClick={() => { playClick(); dispatch({ type: 'game-compass', state: 'cover' }); }}>
          <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/1-game-cover/cover-button6`} src1=".svg" src2="-select.svg" alt="羅盤"></SvgButton>
        </button>
        <button className="cover-button-caption cover-button-caption-game-compass" style={{ left: 252, top: 283, width: 143, height: 109 }} onClick={() => { playClick(); dispatch({ type: 'game-compass', state: 'cover' }); }}>
          <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/1-game-cover/cover-button2`} src1=".svg" src2=".svg" alt="羅盤"></SvgButton>
        </button>

        <button className="cover-button" style={{ right: -27, bottom: 53, width: 365, height: 452 }} onClick={() => { playClick(); dispatch({ type: 'game-gunpowder', state: 'cover' }) }}>
          <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/1-game-cover/cover-button7`} src1=".svg" src2="-select.svg" alt="火藥"></SvgButton>
        </button>
        <button className="cover-button-caption cover-button-caption-game-gunpowder" style={{ right: 30, top: 137, width: 143, height: 116 }} onClick={() => { playClick(); dispatch({ type: 'game-gunpowder', state: 'cover' }) }}>
          <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/1-game-cover/cover-button4`} src1=".svg" src2=".svg" alt="火藥"></SvgButton>
        </button>

        <button className="cover-button" style={{ left: 38, bottom: 18, width: 208, height: 532 }} onClick={() => { playClick(); dispatch({ type: 'game-paper-making', state: 'cover' }); }}>
          <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/1-game-cover/cover-button8`} src1=".svg" src2="-select.svg" alt="造紙術"></SvgButton>
        </button>
        <button className="cover-button-caption cover-button-caption-game-paper-making" style={{ left: 165, top: 104, width: 144, height: 118 }} onClick={() => { playClick(); dispatch({ type: 'game-paper-making', state: 'cover' }); }}>
          <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/1-game-cover/cover-button1`} src1=".svg" src2=".svg" alt="造紙術"></SvgButton>
        </button>
      </div>
    </div>
  )
}
